import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

const FeatureCard = ({ title, description }) => {
  return (
    <Card className={cn(
      "w-full border-border/50",
      "bg-gradient-to-br from-primary/10 via-primary/5 to-background",
      "shadow-md hover:shadow-lg transition-shadow duration-300"
    )}>
      <CardContent className="p-6">
        <Heading level="h3" className="text-lg font-semibold mb-2 text-foreground">
          {title}
        </Heading>
        <Text variant="muted" className="text-sm">
          {description}
        </Text>
      </CardContent>
    </Card>
  );
};

export default FeatureCard;